import { Platform } from 'react-native';

import actions, { navigate } from '../../actions';
import { VERSION } from '../../config';
import { SCHEME } from '../../scheme';
import { shareItemNew } from '../../services/device';
import { eventBus } from '../../services/eventBus';
import { setFavoritesToStorage } from '../../services/favorites';
import firebaseService from '../../services/firebase';
import { storage } from '../../services/localstorage';
import tracking from '../../services/tracking';
import userService from '../../services/user';
import {
    removeVisitFromLocalStorageByProviderCode,
    removeVisitsFromSync
} from '../../services/user.utils';
import Store, {
    getFromStoreDb,
    putIntoStore
} from '../../store';
import {
    decrypt,
    formatDate,
    urlStringify
} from '../../utils';
import { consoleLog } from '../../utils/log';
import {
    FB_SYNC_KEY,
    PAST_VISITS_KEY
} from '../App/snippets/Tests&Visits/utils';
import {
    copyFromCacheToDocs,
    getAttachmentsInfo,
    getAttachmentsList,
    isCachePath
} from '../Services/Backup/common/visitAttachments';

const {
    VISITS_PREFILTER,
    VISITS_FILTER,
    TESTS_PREFILTER,
    TESTS_FILTER,
} = SCHEME;

export const goToVisitsFilter = async (c, d, v, s) => {
    const {
        visitors = [],
        byAttachments = false,
        byReports = false,
        clinics = [],
        doctors = [],
        speciality = [],
    } = getFromStoreDb(VISITS_FILTER) || {};
    putIntoStore(VISITS_PREFILTER, {
        visitors: v.map((e) => ({
            id: e.id,
            name: e.name,
            selected: visitors.some((id) => id === e.id),
        })),
        clinics: c.map((e) => ({
            ...e,
            selected: clinics.some((id) => id === e.id),
        })),
        doctors: d.map((e) => ({
            ...e,
            selected: doctors.some((id) => id === e.id),
        })),
        speciality: s.map((e) => ({
            ...e,
            selected: speciality.some((id) => id === e.id),
        })),
        byAttachments,
        byReports,
    });
    navigate('VisitsFilter');
};

export const goToTestsFilter = async (c, s, v) => {
    const {
        visitors: _visitors = [],
        clinics: _clinics = [],
        statuses: _statuses = [],
    } = getFromStoreDb(TESTS_FILTER) || {};
    const {
        me,
        relatives,
    } = await userService.getUserInfo();
    const persons = [
        {
            id: me.profileId,
            name: Object.R('titles.for_me'),
        },
        ...relatives.map(({
            profileId,
            name,
        }) => ({
            id: profileId,
            name: name?.split?.(' ')?.[1] ?? name ? name : '',
        })),
    ];

    const visitors = v.map((e) => ({
        id: e.id,
        name: persons.find((p) => p.id === e.id)?.name,
        selected: _visitors.some((id) => id === e.id),
    }));
    const clinics = c.map((e) => ({
        ...e,
        selected: _clinics.some((id) => id === e.id),
    }));
    const statuses = s.map((e) => ({
        ...e,
        selected: _statuses.some((id) => id === e.id),
    }));
    putIntoStore(TESTS_PREFILTER, {
        // visitors: persons.map(e => ({ id: e.id, name: e.name, selected: visitors.some(id => id === e.id) })),
        visitors,
        clinics,
        statuses,
    });
    navigate('TestsFilter');
};

export const shareVisit = (visit) => {
    const ve = Store?.getState()?.visitEdit;
    if (ve?.id === visit?.id) {
        visit = ve;
    }

    const url = urlStringify({ target: Object.R('shareDoctor.sourceLink') });
    const store = Store.getState()?.user?.info;
    const getVisitor = () => {
        if (visit?.visitor?.isMe) {
            return `${visit?.visitor?.subName} (${formatDate(store?.birthday) ?? ''})`;
        }
        return visit?.visitor?.name
            ? `${visit?.visitor?.name} (${formatDate(visit?.visitor?.birthday ?? '-')})`
            : visit?.customerFirstName;
    };

    const getDrugs = () => {
        return (
            visit?.drugs?.map(({
                ls_name = '',
                tar_name = '',
            }) =>
                `${ls_name} ${tar_name ? `(${tar_name})` : ''}`.trim(),
            ) ?? []
        ).join(', ');
    };

    const messageObject = {
        'shareDoctor.date': visit?.visitItemDate ?? '',
        'shareDoctor.service': visit?.serviceName ?? '',
        'shareDoctor.doctor': `${visit?.physicianName ?? ''}${
            visit?.specialization ? ` (${visit?.specialization})` : ''
        }`,
        'shareDoctor.clinic': visit?.branchName
            ? `${visit?.branchName}${visit?.address ? ` (${visit?.address})` : ''}`
            : '',
        'shareDoctor.profile': getVisitor(),
        'shareDoctor.comment': visit?.comment ?? '',
        'shareDoctor.drugs': getDrugs(),
        'shareDoctor.source': url,
    };
    const message = Object.entries(messageObject)
        .filter(([ key, value ]) => value?.trim?.()?.length && Object.R(key) !== key && Object.R(key)
            ?.trim
            ?.()?.length)
        .map(([ key, value ]) => `${Object.R(key)} ${value}`)
        .join(
            Object.R('shareDoctor.separator', { lineFeed: '\n' }) !== 'shareDoctor.separator'
                ? Object.R('shareDoctor.separator', { lineFeed: '\n' })
                : ', ',
        );
    shareItemNew(Object.R('titles.shareDoctorTitle'), message, () => {
        tracking.logEvent('shareVisit');
    });
};

export const getVisitDataFromFB = () => {
    const key = FB_SYNC_KEY;
    const past = PAST_VISITS_KEY;
    eventBus.on('mergeUserInfo', async (info = {}) => {
        consoleLog(` === MERGE USER INFO === ${key} ${past}`, info);
        const removeVisitProvider = await storage.get('remove_visit_provider');
        const syncedVersion = await storage.get('syncedVersion');

        const {
            me,
            storeKey,
            hashKey,
        } = info;
        const { profileId } = me ?? {};

        const visitsReady = ({
            data = [],
            message = 'OK',
        }) => {
            consoleLog(' === VISITS READY === EMIT', {
                data,
                message,
            });
            try {

                eventBus.emit('visitsReady', {
                    key,
                    past,
                    data: (data ?? [])?.map?.((v) => decrypt(v, hashKey)),
                    profileId,
                    me,
                    message,
                });
            } catch (e) {
                consoleLog('Error in visitsReady eventBus emit', e);
            }
        };


        if (!storeKey || !profileId || !hashKey) {
            visitsReady({
                adata: [],
                message: 'no storeKey or profileId or hashKey',
            });
            return;
        }

        if (typeof syncedVersion === 'string' && syncedVersion !== 'undefined') {
            const authVersion = await storage.get('authVersion');
            if (typeof authVersion === 'string') {
                const docs = await storage.getObject(key, {});
                const storedDocs = docs[info?.me?.profileId] || [];
                await storage.set(past, storedDocs);
                await storage.remove('authVersion');
                // const f = await getFavoritesFromStorage(profileId, hashKey);
                await removeVisitFromLocalStorageByProviderCode(removeVisitProvider, 'past', hashKey);
                await removeVisitFromLocalStorageByProviderCode(removeVisitProvider, 'future', hashKey);
                await removeVisitsFromSync(removeVisitProvider, profileId, hashKey);
                visitsReady({
                    data: storedDocs,
                    message: 'from storage all',
                    hashKey,
                });
            } else {
                const visits = (await storage.get(past, [])) ?? [];
                visitsReady({
                    data: visits,
                    message: 'from storage',
                    hashKey,
                });
            }
        } else {
            firebaseService.collection(`profile/${info?.storeKey}/pastVisits`)
                .onSnapshot(async (data) => {
                    const docs = data.docs.map((doc) => doc.data()?.data);
                    const storedDocs = await storage.getObject(key, {});
                    storedDocs[info?.me?.profileId] = docs;
                    await storage.set(past, docs);
                    try {
                        await storage.set(key, storedDocs);

                    } catch (err) {

                        console.log(`error set ${key}`, { err });
                    }
                    await removeVisitFromLocalStorageByProviderCode(removeVisitProvider, 'past', hashKey);
                    await removeVisitFromLocalStorageByProviderCode(removeVisitProvider, 'future', hashKey);
                    await removeVisitsFromSync(removeVisitProvider, profileId, hashKey);
                    await storage.set('syncedVersion', VERSION?.split?.('.')
                        .slice(0, 3)
                        .join('.'));
                    visitsReady({
                        data: docs,
                        message: 'from fb',
                        hashKey,
                    });
                });

            firebaseService
                .getById('profile', info?.storeKey)
                .then((d) => {
                    const fullFavorites = decrypt(d?.prefs ?? '', hashKey)?.fullFavorites;
                    if (fullFavorites && Array.isArray(fullFavorites)) {
                        setFavoritesToStorage(fullFavorites, profileId, hashKey);
                    }
                })
                .catch(console.log);
        }

    });
};

const copyAttachFromCacheToDocs = async (params) => {
    Platform.OS === 'android' &&
    setTimeout(async () => {
        const copyReady = await storage.get('copyFromCacheToDocsReady', false);

        const {
            data,
            hashKey,
            profileId,
        } = params || {};
        let visits = [];
        console.log(` === VISITS READY === ${profileId}`, {
            data,
            hashKey,
            copyReady,
        });
        if (data?.length) {
            visits = [ ...data ];
            console.log('visits ready ok');
        } else if (profileId && hashKey) {
            const d = await storage.getObject(PAST_VISITS_KEY, []);
            visits = d?.map?.((v) => decrypt(v, hashKey)) || [];
            console.log('visits ready no data, try to get', d);
        } else {
            console.log('visits ready no data, no profileId or hashKey');
            return;
        }
        const attachments = getAttachmentsList(visits);
        const info = await getAttachmentsInfo(attachments);
        // console.log('visits ready', {
        //     visits,
        //     attachments,
        //     info: info?.info?.attachments,
        // });
        let isDone = false;
        for (const att of info?.info?.attachments || []) {
            isDone = true;
            if (isCachePath(att?.path)) {
                await copyFromCacheToDocs(att?.path);
            }
        }
        if (isDone) {
            await storage.set('copyFromCacheToDocsReady', true);
        }
    }, 1000);
};

export const loadProviderCodes = (visits) => {
    try {
        const branches = Array.from(new Set(visits?.data?.map?.(b => b.branchId) ?? []));
        actions.loadProviderCodes({ branches });
    } catch (e) {
        console.error('!!!Error load provider codes', e);
    }
};

eventBus.on('visitsReady', copyAttachFromCacheToDocs);
